module.exports = __webpack_public_path__ + "static/media/14.086e2ddf.jpg";